import GraphCard from './GraphCard';

export default GraphCard;
